import React, { Fragment, useState } from 'react';
import { Button, useUpdateMany, useTranslate, useDataProvider, useListContext, useNotify, useRefresh, useUnselectAll } from 'react-admin';
import CheckIcon from '@mui/icons-material/Check';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function ValidateDevices() {
    const [isOpen, setIsOpen] = useState(false);
    const translate = useTranslate();
    const dataProvider = useDataProvider();

    const { selectedIds } = useListContext();
    const [updateMany, { isLoading }] = useUpdateMany();
    const notify = useNotify();

    const refresh = useRefresh();
    const unselectAll = useUnselectAll('devices');

    const handleClick = () => {
        setIsOpen(true);
    }

    const handleDialogClose = () => {
        setIsOpen(false);
    };

    const handleConfirm = async () => {

        //Check all Ids statuses and ignore the ones that aren't 2
        var validIds = [];
        await asyncForEach(selectedIds, async (response) => {
            if (response.data.error) {
                //Ex: Invalid cast Id
                console.log(response.data.error.message);
            }
            else if (response.data.message) {
                //Ex: No entries found
                console.log("id: " + response.data.id + "; Message: " + response.data.message);
            }
            //TO_SM_245: We need to exclude devices rejected two times already
            else if (response.data.status && response.data.status.codice === '2' && response.data.contatore !== 2) {
                validIds.push(response.data.id);
            }
        });
        var user = localStorage.getItem('username');

        updateMany( 'devices', { ids: validIds, data: { status: { codice: '3' }, validated_at: new Date(), validated_by: user } }, {
            onSuccess: (data) => {
                let updated = 0;
                data?.forEach(d => { if(d.message && d.message === 'Updated') updated++});
                // refresh();
                notify(updated + " records aggiornati", { type: 'info' });
                handleDialogClose();
                unselectAll();
                refresh();
            } });
    };

    const asyncForEach = async (array, callback) => {
        for (let index = 0; index < array.length; index++) {
            //await callback(array[index], index, array);
            await dataProvider.getOne('devices', { id: array[index] })
                .then(
                    response => {
                        if (response.data.message) {
                            callback(response);
                        }
                        else {
                            callback(response);
                        }
                    })
                .catch(error => {
                    callback(error);
                });
        }
    };

    return (
        <Fragment>
            <Button label='tim.validatedevices.button_label' onClick={handleClick} >
                <CheckIcon />
            </Button>
            {/* <Confirm
                isOpen={isOpen}
                title='validatedevices.title'
                content='validatedevices.content'
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            /> */}
            <Dialog
                open={isOpen}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{translate('tim.validatedevices.title')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {translate('tim.validatedevices.content')}
                        <br />
                        {translate('tim.validatedevices.rejected_warning')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} label='tim.validatedevices.cancel' color="inherit" autoFocus />
                    <Button onClick={handleConfirm} disabled={isLoading} label='tim.validatedevices.confirm' color="primary" autoFocus />
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}

export default ValidateDevices;